


































import {Component, Vue, Provide} from 'vue-property-decorator'
import AppDrawer from './components/AppDrawer.vue'
import AppToolbar from './components/AppToolbar.vue'
import PageHeader from './components/PageHeader.vue'

@Component({
    components: {
        AppDrawer,
        AppToolbar,
        PageHeader
    }
})
export default class App extends Vue {
    private year: number = new Date().getFullYear()
    private currentTime: string = ''

    @Provide() showDrawer: boolean = this.$store.state.showDrawer
    @Provide() mini: boolean = false

    getTimeString() {
        setInterval(() => {
            var d = new Date()
            var localTime = d.getTime()
            var localOffset = d.getTimezoneOffset() * 60000
            var utc = localTime + localOffset
            var offset = 8
            var beijing = utc + (3600000 * offset)
            var ld = new Date(beijing)

            var year = ld.getFullYear()
            var month = ld.getMonth() + 1
            var day = ld.getDate()
            var hour = ld.getHours()
            var minute = ld.getMinutes()
            var second = ld.getSeconds()

            var timeString = year + '年' + month + '月' + day + '日' + hour + '时' + minute + '分' + second + '秒'

            this.currentTime = timeString
        }, 1000)
    }

    handleDrawerVisiable() {
        const width = window.innerWidth || document.body.clientWidth

        if (width < 1260) {
            this.mini = true
        } else {
            this.mini = false
        }

        if (this.mini) {
            this.showDrawer = !this.showDrawer
            this.showDrawer = !this.showDrawer
        } else {
            this.showDrawer = !this.showDrawer
        }

        this.$store.commit('setShowDrawer', this.showDrawer)
    }

    mounted() {
        this.getTimeString()

        let win: any = window
        if (!!win.ActiveXObject || 'ActiveXObject' in window) {
            window.addEventListener('hashchange', () => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath);// 主动更改路由界面
                }
            }, false);
        }


        //this.$vuetify.dataIterator = {
        //    rowsPerPageText: '每页记录数：',
        //    rowsPerPageAll: '全部',
        //    pageText: '{0}-{1} 共 {2} 条',
        //    noResultsText: '没有找到匹配记录',
        //    nextPage: '下一页',
        //    prevPage: '上一页'
        //}

        //    = {
        //    dataIterator: {
        //        rowsPerPageText: '每页记录数：',
        //        rowsPerPageAll: '全部',
        //        pageText: '{0}-{1} 共 {2} 条',
        //        noResultsText: '没有找到匹配记录',
        //        nextPage: '下一页',
        //        prevPage: '上一页'
        //    },
        //    dataTable: {
        //        rowsPerPageText: '每页行数：'
        //    },
        //    noDataText: '无可用数据',
        //    carousel: {
        //        prev: '以前的视觉',
        //        next: '下一个视觉'
        //    }
        //}
    }

    AddFavorite() {
        let win: any = window
        win.external.AddFavorite('http://localhost:8091/', '数据管理系统')
    }
}
